module.exports = __webpack_public_path__ + "media/img/files/file-2-e26096399de50aeb47dd5e454726a8df.jpg";